// Types
import type { TApiHttpClientRequestConfig, TPaginated } from '~/misc/resource/types';
import type { TAutomatedEmailOutboxApiRow, TOutboxEmail } from '~/modules/opportunities/automated-email/types';
import type {
  TAutomatedEmailOutboxListQuery,
  TOutboxSendPayload,
} from '~/modules/opportunities/automated-email/outbox/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

// Utils
import { mapAutomatedEmailOutboxApiRow } from '~/modules/opportunities/automated-email/outbox/utils/map-outbox-api';

export class OutboxModel extends DefaultResource {
  protected endpoint: string = 'automated-email/';

  getOutboxPage(
    query: TAutomatedEmailOutboxListQuery,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginated<TOutboxEmail>> {
    return this
      .get<TPaginated<TAutomatedEmailOutboxApiRow>>('outbox', query, requestConfig)
      .then((res: TPaginated<TAutomatedEmailOutboxApiRow>): TPaginated<TOutboxEmail> => ({
        data: res.data.map(mapAutomatedEmailOutboxApiRow),
        meta: res.meta,
      }));
  }

  /** `POST /api/automated-email/outbox/{outbox}/send` — queues the email (202). */
  sendOutboxEntry(
    outboxId: number,
    payload?: TOutboxSendPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    const body: TOutboxSendPayload | undefined =
      payload?.subject !== undefined || payload?.content !== undefined ? payload : undefined;

    return this.post<void>(`outbox/${outboxId}/send`, body, requestConfig);
  }

  /** `DELETE /api/automated-email/outbox/{outbox}/dismiss` — removes the entry (204). */
  dismissOutboxEntry(
    outboxId: number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.delete<void>(`outbox/${outboxId}/dismiss`, {}, requestConfig);
  }
}
